// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__n2ikn","largestCol":"styles_largestCol__1lE99","smallestCol":"styles_smallestCol__1Douu"};